import { getOmjsProjectInstance } from 'selectors';
import { Feature } from 'ol';
import { MultiPolygon, Polygon } from 'ol/geom';

export * from './objects-helper';
export * from './key-codes';
export * from './file';
export * from './deep-equal';

export const detectIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');
    const edge = ua.indexOf('Edge/');
    let rv;

    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    if (trident > 0) {
        // IE 11 => return version number
        rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
};

export const dataURIToBlob = (dataURI: string, format?: 'png' | 'jpeg') => {
    const binStr = atob(dataURI.split(',')[1]);
    const len = binStr.length;
    const arr = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
    }

    return new Blob([ arr ], {
        type: `image/${format}`
    });
};

export function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

export const mergeDeep = (target, source) => {
    let output;
    if (!isObject(target) || !isObject(source)) {
        output = isObject(source) ? { ...source } : source;
    } else {
        output = { ...target };
        Object.keys(source).forEach((key) => {
            if (isObject(source[key])) {
                if (!(key in target)) {
                    Object.assign(output, { [key]: source[key] });
                } else {
                    output[key] = mergeDeep(target[key], source[key]);
                }
            } else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }

    return output;
};

/* eslint-disable-next-line arrow-body-style */
export const formatApiUrl = (api_url_template: string) => {
    return api_url_template.replace('%version', window['omjs'].version);
};

export const parseJSONSafe = (str) => {
    let strForParse = str;
    try {
        strForParse = strForParse.replace(/&quot;/g, '"');
        strForParse = JSON.parse(strForParse);
    } catch (err) {
        strForParse = {};
    }
    return strForParse;
};

export const fuzzyMatch = (needle: string, text: string): boolean => {
    if (!text) {
        return false;
    }

    let pattern = `.*${needle.toLowerCase().split('').join('.*')}.*`;
    let reg = new RegExp(pattern);
    return reg.test(text.toLowerCase());
};

export const getContainerIcon = (cont: omjs.IContainer) => {
    let project = getOmjsProjectInstance(false);
    let iconUrl = cont.icon;
    if (iconUrl.length) {
        if (iconUrl.charAt(0) !== '/') {
            iconUrl = `/${iconUrl}`;
        }
        let port = project.apiUrlLocation.port ? `:${project.apiUrlLocation.port}` : '';
        iconUrl = `${project.apiUrlLocation.protocol}//${project.apiUrlLocation.hostname}${port}${iconUrl}`;
    }
    return iconUrl;
};

export const htmlDecode = (input) => {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
};

export const freeSpace = {
    element: null,
    setElement: function(element) {
        this.element = element;
    }
};

export const getMaxPolygonFromMultiPolygon = (geometry: MultiPolygon): Polygon => {
    const polygons = geometry.getPolygons();
    let largestPolygon = polygons[0];
    let maxArea = largestPolygon?.getArea();

    if (maxArea) {
        for (const p of polygons) {
            const currentArea = p.getArea();
            if (currentArea > maxArea) {
                maxArea = currentArea;
                largestPolygon = p;
            }
        }
    }
    return largestPolygon;
};
